import { H3, H6, LI, UL } from "../../../AbstractElements";
import { Checkout, GoToYourCart, OrderTotal } from "../../../Constant";
import { Link } from "react-router-dom";
import CartList from "./CartList";

export const Cart = () => {
  return (
    <div className="cart-dropdown onhover-show-div">
      <H3 className="f-18 mb-0 dropdown-title">Cart</H3>
      <UL>
        <CartList />
        <LI className="total">
          <H6 className="mb-0">
            {OrderTotal} : <span className="f-right">$1000.00</span>
          </H6>
        </LI>
        <LI className="text-center check-button">
          <Link className="d-block mb-3 view-cart f-w-500" to={`${process.env.PUBLIC_URL}/ecommerce/cart`}>
            {GoToYourCart}
          </Link>
          <Link className="btn btn-primary view-checkout" to={`${process.env.PUBLIC_URL}/ecommerce/checkout`}>
            {Checkout}
          </Link>
        </LI>
      </UL>
    </div>
  );
};
